// ===========================================================================
// No Recent Visits — constantes compartidas del módulo.
//
// Catálogos fijos (time buckets, metal levels), paletas de color consistentes
// (severidad de tiempo desde la última visita, networks, metal) y defaults de
// paginación. Reutilizadas en donuts, badges de la tabla, filter chips y la
// vista mobile.
//
// Referencia de diseño: docs/modulos/NoRecentVisit/CAT3_UIUX_NO_RECENT_VISITS.md
// ===========================================================================

export const NO_RECENT_VISIT_BASE_PATH = "/no-recent-visits";

export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Time buckets en orden de severidad ascendente (<3 → 12+). El orden del array
// es el orden fijo que deben respetar el donut, los radios del filtro y el
// chip. El backend devuelve los buckets en este mismo orden lógico.
export const TIME_BUCKETS = ["<3 Months", "3 Months", "6 Months", "9 Months", "12+ Months"];

// Color sólido por bucket (donut Time Since). Gradiente verde → rojo.
export const TIME_BUCKET_COLORS = {
  "<3 Months": "#22c55e",
  "3 Months": "#84cc16",
  "6 Months": "#eab308",
  "9 Months": "#f97316",
  "12+ Months": "#ef4444",
};

// Color del badge pill por bucket (fondo claro + texto oscuro, WCAG AA).
// Usado en la columna "Time Since Last Visit", filter chips y vista mobile.
export const TIME_BUCKET_BADGE_COLORS = {
  "<3 Months": { bg: "#dcfce7", text: "#166534" },
  "3 Months": { bg: "#ecfccb", text: "#3f6212" },
  "6 Months": { bg: "#fef9c3", text: "#854d0e" },
  "9 Months": { bg: "#fed7aa", text: "#9a3412" },
  "12+ Months": { bg: "#fee2e2", text: "#991b1b" },
};

// Metal levels (catálogo fijo, solo aplica a ACA).
export const METAL_LEVELS = ["Bronze", "Silver", "Gold", "Platinum"];

// Color del badge de metal level. Fondo claro + texto oscuro para legibilidad.
export const METAL_LEVEL_COLORS = {
  Bronze: { bg: "#f3e3d3", text: "#7a4a1e" },
  Silver: { bg: "#eceff1", text: "#546e7a" },
  Gold: { bg: "#fdf3d0", text: "#8a6d18" },
  Platinum: { bg: "#eceeef", text: "#5b6168" },
};

// Paleta categórica para el donut de Networks. Se cicla si hay más networks.
export const NETWORK_PALETTE = [
  "#1976d2",
  "#7b1fa2",
  "#00897b",
  "#f9a825",
  "#ef6c00",
  "#5e35b1",
  "#c2185b",
  "#546e7a",
];

// Genérico de "sin dato" para campos opcionales que pueden llegar null.
export const EMPTY_PLACEHOLDER = "—";
export const UNASSIGNED_LABEL = "Unassigned";

/** Devuelve el color del donut para un time bucket (gris si no mapea). */
export const timeBucketColor = (bucket) => TIME_BUCKET_COLORS[bucket] || "#9e9e9e";

/** Devuelve un color categórico estable para un network según su índice. */
export const networkColor = (index) => NETWORK_PALETTE[index % NETWORK_PALETTE.length];
